module.exports = __webpack_public_path__ + "static/img/bg4.09ebaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/bg4.png
// module id = NK4S
// module chunks = 0